import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {withApollo} from 'react-apollo';
import {withTranslation} from 'react-i18next';
import AsyncSelect from 'react-select/async';
import {COLORS} from '../../constants';

const defaultStyles = (lightStyles = false) => ({
  control: (provided) => ({
    ...provided,
    fontSize: 'inherit',
    color: COLORS.SELECT_BLACK,
    borderRadius: '5px',
    borderColor: lightStyles ? COLORS.BACKGROUND_GRAY : '#d0d1df',
    backgroundColor: COLORS.WHITE,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: COLORS.SELECT_GRAY,
  }),
  placeholder: (provided) => {
    if (lightStyles) {
      return {
        ...provided,
        color: COLORS.SELECT_GRAY,
        width: 'max-content',
      };
    } else {
      return provided;
    }
  },
});

const SearchSelect = ({t, loadOptions, placeholder, noOptionsMessage, styles, loadingMessage, lightStyles, isMulti, initialSelectedValues, onChange, ...props}) => {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState([]);

  useEffect(() =>  {
    if (initialSelectedValues && options.length > 0) {
      const optionsToSet = options.filter(option => initialSelectedValues.findIndex(selectedValue => option.value === selectedValue) > -1);
      if (optionsToSet.length > 0) {
        setValue(optionsToSet);
      }
    }
  }, [initialSelectedValues, options, isMulti]);

  return (
    <AsyncSelect
      isMulti={isMulti}
      loadOptions={(query, callback) => {
        const internalCallback = (options) => {
          setOptions(options);
          callback(options);
        };
        loadOptions(query, internalCallback);
      }}
      cacheOptions
      defaultOptions
      placeholder={placeholder ? placeholder : t('selectPlaceholder')}
      noOptionsMessage={() => noOptionsMessage ? noOptionsMessage : t('noResultsSelect')}
      loadingMessage={() => loadingMessage ? loadingMessage : t('loadingMessageSelect')}
      styles={{...defaultStyles(lightStyles), ...styles}}
      value={value}
      onChange={(option, ...args) => {
        setValue(option);
        onChange(option, ...args);
      }}
      {...props}
    />
  );
};

SearchSelect.defaultProps = {
  placeholder: null,
  noOptionsMessage: null,
  loadingMessage: null,
  styles: {},
  lightStyles: false,
  isMulti: false,
  initialSelectedValues: [],
  onChange: () => {},
};

SearchSelect.propTypes = {
  loadOptions: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  styles: PropTypes.object,
  loadingMessage: PropTypes.string,
  lightStyles: PropTypes.bool,
  isMulti: PropTypes.bool,
  initialSelectedValues: PropTypes.array,
  onChange: PropTypes.func,
};

export default withApollo(withTranslation('common')(SearchSelect));
